import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class MwCheckbox extends Component {
  @action
  onChange(event) {
    const checked = event.target.checked;
    this.args.onChange?.(checked);
  }

  @action
  onInput(event) {
    const checked = event.target.checked;
    this.args.onInput?.(checked);
  }
}
